/**
 * Resolve node-type input schemas for Connect-mode auto-wiring.
 * Only `rag-retrieve` declares a concrete object input today; everything
 * else is an open record and uses passthrough field matching.
 */

import { topLevelKeys } from '../MappingRow';

import { normalizeRegistryJsonSchema } from './node-type-schemas';

/** Top-level input field names from a node-type registry input schema. */
export function getNodeTypeInputFieldNames(
  nodeType: string,
  nodeTypeInputSchemaByKey: ReadonlyMap<string, Record<string, unknown> | null>,
): string[] {
  const raw = nodeTypeInputSchemaByKey.get(nodeType) ?? null;
  const schema = normalizeRegistryJsonSchema(raw);
  return topLevelKeys(schema);
}

/** True when the type declares a fixed set of input properties (e.g. rag-retrieve `query`). */
export function hasConcreteInputSchema(
  nodeType: string,
  nodeTypeInputSchemaByKey: ReadonlyMap<string, Record<string, unknown> | null>,
): boolean {
  return getNodeTypeInputFieldNames(nodeType, nodeTypeInputSchemaByKey).length > 0;
}
